import { render, staticRenderFns } from "./NewServiceDocumentPage.vue?vue&type=template&id=279c0e40&scoped=true"
import script from "./NewServiceDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewServiceDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c0e40",
  null
  
)

export default component.exports